<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    华强南站<br>
站点介绍<br>
华强南站位于华强南路与福华路交口南侧，沿华强南路方向布置。 A出口为南华花园，B出口为赛格公寓，C出口为上步商业大厦及财富酒店，D出口为市中医院。华强南站主要与市中医院连接，方便乘客就诊。本站采用天蓝色彩基础色调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:37	23:17	7号线	3分35秒	5分55秒<br>
太安	06:12	23:39	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:36	23:17	7号线	4分钟	5分55秒<br>
太安	06:10	23:39	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:37	00:17	7号线	4分钟	5分55秒<br>
太安	06:10	00:39	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
华强南路东侧（南）、南华花园、爱尔眼科医院、南园小学、南园派出所<br><br>
B出入口:<br>
华强南路东侧（北）、赛格苑、南园商廊、爱华住宅小区、南园路<br><br>
C出入口:<br>
华强南路西侧（北）、华强花园、深圳市中医院（北门）<br><br>
D出入口:<br>
华强南路西侧（南）、深圳市中医院（正门）、无线电管理大厦、福田区第二实验学校、福景路<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 华强南<br>
13路,23路，B930路<br><br>
D出入口:<br>
公交站名： 华强南<br>
13路,216路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>